var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"panel-box-action",attrs:{"loading":this.isLoading,"disabled":this.isDisabled ? this.isDisabled : this.isLoading},on:{"click":function($event){return _vm.handler()}}},[_vm._v(" "+_vm._s(this.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }